export default {
  login: "Kirjaudu",
  register: "Rekisteröidy",
  loginWithEmail:
    "Onko sinut kutsuttu käyttäjäksi? <0>Kirjaudu sähköpostilla</0>.",
  buyParkingPermit: "Osta pysäköintilupa",
  manageVehicles: "Hallinnoi ajoneuvoja",
  wellbeingServicesCounty: "Pohjois-Pohjanmaan hyvinvointialue",
  errors: {
    LimitExceededException:
      "Liian monta yritystä. Kokeile hetken päästä uudelleen.",
  },
  unknownError: "Tapahtui odottamaton virhe. Yritä myöhemmin uudelleen.",
  navbar: {
    title: "Henkilöstöpysäköinti",
    menuTooltip: "Avaa valikko",
    finnish: "Suomeksi",
    english: "In English",
    swedish: "På svenska",
    logout: "Kirjaudu ulos",
    userDetails: "Käyttäjätiedot",
    drawer: {
      firstPage: "Etusivu",
      shop: "Verkkokauppa",
      userInfo: "Omat tiedot, luvat ja ajoneuvot",
      helpdesk: "Helpdesk",
      faq: "Katso vastaukset kysytyimpiin kysymyksiin",
      termsAndConditions: "Käyttöehdot",
      privacyPolicy: "Tietosuojaseloste",
      contactInformation: "Yhteystiedot",
      paymentPolicy: "Maksuehdot",
    },
  },
  contactInfo: {
    webshop:
      "Pohjois-Pohjanmaan hyvinvointialueen henkilöstöpysäköinnin verkkokauppa",
    title: "Yhteystiedot",
    name: "Moovy Oy",
    noCustomerService: "Huom. Ei asiakaspalvelua",
    email: "Sähköposti",
    emailContent: "support@pohde.zendesk.com",
    businessId: "Y-tunnus",
    businessIdContent: "3375902-1",
    postAddress: "Postiosoite",
    postAddressContent: "PL 15",
    city: "33211 Tampere",
  },
  paymentPolicy: {
    title: "Maksupalvelutarjoaja",
    paragraphs: [
      `Maksunvälityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) 
			yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa. 
			Paytrail Oyj näkyy maksun saajana tiliotteella tai korttilaskulla ja välittää maksun kauppiaalle. 
			Paytrail Oyj:llä on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyydämme ottamaan ensisijaisesti yhteyttä tuotteen toimittajaan.`,
      "Paytrail Oyj, y-tunnus: 2122839-7",
      "Innova 2",
      "Lutakonaukio 7v",
      "40100 Jyväskylä",
    ],
    paytrailUrl: "https://paytrail.com/kuluttaja/tietoa-maksamisesta",
  },
  privacyPolicy: {
    title: "Tietosuojaseloste",
    paragraphs: [
      `Rekisteröidyn informointi, EU:n yleinen tietosuoja-asetus (2016/679) 12-14 art. Seloste päivitetty  31.3.2025`,
      `1. Rekisterin nimi`,
      `Pohjois-Pohjanmaan hyvinvointialueen pysäköintijärjestelmän asiakasrekisteri.`,
      `2. Rekisterinpitäjä`,
      `Pohjois-Pohjanmaan hyvinvointialue`,
      `PL 10`,
      `90029 POHDE`,
      `3221326–2`,
      `3. Rekisterin vastuuhenkilö`,
      `Ollipekka Huotari, tekninen johtaja, 050 322 7287, ollipekka.huotari@pohde.fi`,
      `4. Rekisterin yhteyshenkilö`,
      `Tommi Juusola, tila-asiantuntija, 050 338 4670, tommi.juusola@pohde.fi`,
      `5. Tietosuojavastaava`,
      `Tommi Juusola, tila-asiantuntija, 050 338 4670, tommi.juusola@pohde.fi`,
      `Pohteen tietosuojavastaava`,
      `PL 10, 90029 Pohde`,
      `tietosuoja@pohde.fi`,
      `08-669 9500 (vaihde)`,
      `6. Tietojen käsittelyn tarkoitus ja oikeusperuste`,
      `Rekisterin tietoja käsitellään pysäköintijärjestelmään rekisteröidyn asiakassuhteen hoitamiseen liittyen. Näitä asioita ovat asiakasviestintä/asiakaspalvelu, laskutus-/maksutietojen ja käyttöoikeuksien hallinta, sopimushallinta sekä tapahtumien varmentaminen.`,
      `7. Rekisterin tietosisältö`,
      `Rekisterissä säilytetään seuraavia henkilötietoja:`,
      `Rekisteröidystä eli pysäköintiluvan lunastajasta tallennetaan tarvittavat henkilötiedot: nimi, työsähköpostiosoite ja ajoneuvon rekisteritunnus/tunnukset. Ajoneuvojen rekisteritunnuksia käsitellään rekisteröidyn pysäköintiluvan kohdentamiseen kyseiselle asiakkaalle.`,
      ``,
      ` Erityiset henkilötiedot:`,
      `Ei käsitellä.`,
      ``,
      `8. Henkilötietojen tietolähteet`,
      `Nimi ja työsähköposti tulevat Pohteen HR-tietojärjestelmästä ja rekisteritunnus lisätään käyttäjän toimesta.`,
      ``,
      `9. Henkilötietojen luovuttaminen rekisteristä`,
      `Pysäköinninvalvojalle toimitetaan käyttäjän rekisteritunnus, mutta muita tietoja ei luovuteta.`,
      ``,
      `10. Henkilötietojen siirto EU:n tai ETA:n ulkopuolelle`,
      `Henkilötietoja ei siirretä EU:n tai ETA-alueen ulkopuolelle kolmansiin maihin.`,
      ``,
      `11. Rekisterin tietojen säilytysaika`,
      `Henkilötietoja säilytetään luvan voimassaoloajan päättymisestä seuraavat 24 kuukautta.`,
      ``,
      `12. Rekisterin suojauksen periaatteet `,
      `Tietojärjestelmä on suojattu asianmukaisin teknisin toimenpitein ulkoisia tietomurtoja vastaan. Rekisteriä voivat käyttää vain ne henkilöt, joiden työtehtäviin sen käyttö kuuluu. Rekisterin käyttöä valvotaan käyttäjäkohtaisilla tunnuksilla ja salasanoilla. Rekisterinpitäjän henkilöstöä sitoo vaitiolovelvollisuus.`,
      ``,
      `13. Rekisteröidyn oikeudet (EU:n tietosuoja-asetus art. 15-18, 20-21, 77)`,
      `Kaikki rekisteröidyn oikeuksiin liittyvät pyynnöt on toimitettava Pohteen kirjaamoon:`,
      `Pohjois-Pohjanmaan hyvinvointialue, Kirjaamo, PL 10, 90029 Pohde`,
      `kirjaamo@pohde.fi. Rekisteröidyn tietojen tarkastusoikeuteen ja tiedon oikaisemiseen liittyvät lomakkeet löytyvät Pohteen verkkosivuilta Tietosuoja-sivulta. `,
      ``,
      `Tietojen tarkastusoikeus`,
      `Rekisteröidyltä on oikeus saada tieto siitä, käsitelläänkö häntä koskevia henkilötietoja. Rekisterinpitäjän on toimitettava jäljennös rekisteröityä koskevista henkilötiedoissa rekisteröidyn niitä pyytäessä.`,
      ` `,
      `Rekisterinpitäjän on toimitettava tiedot viimeistään kuukauden kuluessa pyynnön vastaanottamisesta. Määräaikaa voidaan tarvittaessa jatkaa enintään kahdella kuukaudella ottaen huomioon pyyntöjen monimutkaisuus ja määrä. Rekisterinpitäjän on ilmoitettava tällaisesta viivästymisestä syineen kuukauden kuluessa pyynnön vastaanottamisesta. `,
      ``,
      `Oikeus tiedon oikaisemiseen`,
      `Rekisteröidyllä on oikeus vaatia rekisterinpitäjää oikaisemaan rekisteröityä koskevat epätarkat ja virheelliset henkilötiedot. Oikaisun lisäksi rekisteröidyllä on oikeus saada puutteelliset tietonsa täydennetyiksi. `,
      ``,
      `Jos rekisterinpitäjä ei hyväksy rekisteröidyn vaatimusta tiedon oikaisemisesta, hänen on annettava asiasta kirjallinen todistus. Todistuksessa on mainittava ne syyt, joiden vuoksi vaatimusta ei ole hyväksytty ja kerrottava mahdollisuudesta tehdä valitus valvontaviranomaiselle. `,
      ``,
      `Oikeus vaatia tietojen poistamista`,
      `Rekisteröidyllä on oikeus saada rekisterinpitäjä poistamaan häntä koskevat henkilötiedot edellyttäen, että jokin tietosuoja-asetuksen artiklan 17 momentin 1 edellytyksistä täyttyy. Oikeutta tietojen poistamiseen ei ole, jos esimerkiksi lakisääteisen velvoitteen noudattaminen, yleistä etua koskevan tehtävän toteuttaminen tai julkisen vallan käyttäminen edellyttää tietojen käsittelyä. `,
      ``,
      `Oikeus vaatia käsittelyn rajoittamista`,
      `Rekisteröidyllä on oikeus siihen, että rekisterinpitäjä rajoittaa henkilötietojen käsittelyä, jos kyseessä on yksi seuraavista: `,
      `rekisteröity kiistää henkilötietojen paikkansapitävyyden `,
      `käsittely on lainvastaista ja rekisteröity vastustaa poistamista ja vaatii sen sijaan käytön rajoittamista `,
      `rekisteröity tarvitsee tietoja oikeudellisen vaateen laatimiseksi, esittämiseksi tai puolustamiseksi `,
      `rekisteröity on vastustanut henkilötietojensa käsittelyä henkilökohtaiseen erityiseen tilanteeseensa liittyvällä perusteella.`,
      ` `,
      `Oikeus vastustaa henkilötietojen käsittelyä`,
      `Rekisteröidyllä on oikeus henkilökohtaiseen erityiseen tilanteeseensa liittyvällä perusteella, milloin tahansa vastustaa häntä koskevien henkilötietojen käsittelyä, jos käsittely perustuu yleisen edun mukaisen tehtävän suorittamiseen tai julkisen vallan käyttämiseen. Rekisterinpitäjä ei saa tällöin enää käyttää tietoja, ellei se voi osoittaa, että käsittelyyn on huomattavan tärkeä ja perusteltu syy. `,
      ``,
      `Oikeus siirtää tiedot järjestelmästä toiseen`,
      `Rekisteröidyllä on oikeus saada rekisterinpitäjä siirtämään rekisteröidyn tiedot toiseen tietojärjestelmään toiselle rekisterinpitäjälle. Oikeus siirtoon on vain tilanteessa, jossa käsittely perustuu suostumukseen tai sopimukseen ja käsittely toteutetaan tietojärjestelmässä. Oikeutta siirtoon ei ole tilanteessa, jossa käsittely on tarpeen yleistä etua koskevan tehtävän suorittamiseksi tai julkisen vallan käyttämiseksi. `,
      ``,
      `Rekisteröidyn valitusoikeus`,
      `Rekisteröidyllä on oikeus tehdä valitus tietosuojavaltuutetulle: `,
      `Tietosuojavaltuutetun toimisto`,
      `Ratapihantie 9, 6.krs., 00520 Helsinki / PL 800, 00521 Helsinki`,
      `029 56 66777`,
      `tietosuoja@om.fi`,
      `www.tietosuoja.fi `,
    ],
  },
  parkingMap: {
    title: "Kohteet & luvat",
    listedLocations: "Katso listattuna kaikki kohteet",
    description: `Ostetut henkilöstöpysäköinnin luvat ovat voimassa hyvinvointialueen kaikissa 
		toimipisteissä lukuunottamatta KYSin pysäköintihallinnassa olevaa KYS Puijon sairaalakampusta.`,
  },
  footer: {
    helpdesk: "Helpdesk",
    faq: "Katso vastaukset <0>kysytyimpiin kysymyksiin</0>.",
  },
  home: {
    title: "Henkilöstön lupapysäköinnin verkkokauppa",
    disclaimer: {
      p1: "Huomaathan, että kirjautumisessa sallittuina ovat ainoastaan hyvinvointialueen toimijoiden sähköpostipäätteet.",
      p2: "Näitä ovat @pshyvinvointialue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi ja @jstt.fi.",
    },
    flow: {
      login: {
        title: "Kirjaudu",
        description:
          "Henkilöstöpysäköinnin lupatuotteita voi ostaa vain Pohteen kirjautunut käyttäjä.",
      },
      buyParkingPermit: {
        title: "Osta pysäköintilupa",
        description:
          "Verkkokaupassa luvat on ostettavissa helposti ja ne aktivoituvat käyttöösi tilauksen yhteydessä.",
      },
      manageVehicles: {
        title: "Hallinnoi ajoneuvoja",
        description:
          "Palvelussa pystyt hallinnoimaan luvalle aktivoitua ajoneuvoa. Muista pitää tiedot ajantasalla!",
      },
    },
    webshop: {
      title: "Verkkokauppa",
    },
  },
  loginForm: {
    title: "Kirjaudu sisään",
    email: "Syötä sähköpostiosoite",
    password: "Syötä salasana",
    forgotPassword: "Unohtuiko salasana?",
    submit: "Kirjaudu sisään",
    authenticationError: "Virheellinen sähköpostiosoite tai salasana",
    tokenExpired: "Istuntosi on vanhentunut. Kirjaudu sisään uudelleen.",
  },
  registerForm: {
    title: "Luo tunnus",
    email: "Syötä sähköpostiosoite",
    password: "Syötä salasana",
    confirmPassword: "Syötä salasana uudelleen",
    invalidPassword:
      "Salasanan tulee olla vähintään 8 merkkiä pitkä ja sisältää vähintään yhden numeron, yhden ison kirjaimen ja yhden erikoismerkin.",
    passwordMismatch: "Salasanat eivät täsmää",
    userAlreadyExists:
      "Käyttäjä on jo olemassa. Jos sinulla on ollut pysäköintilupia aiemmassa järjestelmässä tai olet unohtanut salasanasi, <0>voit palauttaa salasanasi täältä</0>.",
    userAlreadyExistsHelpText: "Käyttäjä on jo olemassa",
    invalidEmail:
      "Huomaathan, että sallittuja sähköpostiosoitteita ovat ainoastaan @pshyvinvointialue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi ja @jstt.fi.",
    submit: "Luo tunnus",
    acceptTerms: "Hyväksyn <0>sopimusehdot</0>*",
    acceptTermsRequired: "Hyväksy sopimusehdot jatkaaksesi",
  },
  termsAndConditions: {
    title: "Sopimusehdot",
    heading: "POHJOIS-POHJANMAAN HYVINVOINTIALUEEN HENKILÖSTÖPYSÄKÖINTI",
    general: {
      subheading: "Yleistä tietoa",
      body: `
      Pohjois-Pohjanmaan hyvinvointialueen työntekijät voivat hankkia henkilöstöpysäköintiluvan oman työpisteensä 
      läheisyydestä. Joissakin kohteissa on rajattu määrä myytäviä pysäköintioikeuksia, joten osa alueista voidaan 
      myydä loppuun. Osassa verkkokaupan tuotteissa on rajaton määrä ostettavia pysäköintioikeuksia, mutta tarkempi 
      rajaus tehdään yksittäisellä kiinteistöllä. Esimerkiksi "kausimaksu" paikkoja on rajattomasti myynnissä, mutta 
      tarkemmat lämpöpaikkojen jakamiset tehdään kiinteistökohtaisesti.
      <br><br>
      Pysäköintioikeuden lunastaminen ei takaa paikan saatavuutta. On mahdollista, että kyseisellä alueella ei ole 
      paikkoja vapaana, vaikka olet lunastanut pysäköintioikeuden. Täysien paikkojen tapauksessa ei korvauksia tai 
      hyvityksiä anneta. Pysäköintimaksuja ei palauteta, jos työsuhde päättyy kesken maksetun kauden tai poissaolon, 
      kuten esimerkiksi sairasloman vuoksi. Sähkö- ja hybridiautojen lataaminen sekä sisätilanlämmittimen käyttö on 
      kielletty.`,
    },
    conditions: {
      subheading: "Sopimusehdot",
      parties: {
        subheading: "i. Sopijapuolet",
        body: `
				1. Pysäköintiluvan haltija<br>
				2. Finnpark Oy / Pohjois-Pohjanmaan hyvinvointialue
			`,
      },
      subject: {
        subheading: "ii. Sopimuksen kohde",
        body: `
				Tässä sopimuksessa määritellään pysäköintiluvan ehdot, käyttö ja voimassaoloaika. Pysäköintilupa viittaa 
				maksulliseen (sähköiseen/digitaaliseen) lupaan, jota käytetään henkilö- ja pakettiautoissa, ja joka antaa 
				oikeuden pysäköidä verkkokaupan tuotteen määrittelemälle alueelle, liikennemerkkien mukaisesti.
			`,
      },
      content: {
        subheading: "iii. Sopimuksen sisältö",
        body: `
				Pysäköintilupia myönnetään Pohjois-Pohjanmaan hyvinvointialueen ja sen konsernin henkilöstölle. Ajoneuvon 
				tulee olla liikennekäytössä ja sopijapuolen omistama, hallitsema tai muutoin pysyvästi tai pitkäaikaisesti 
				käytössä. Pysäköintilupa on henkilökohtainen ja sitä saa käyttää vain työhön tai työskentelyyn liittyvässä 
				pysäköinnissä. Lupaa ei saa lainata tai siirtää toiselle henkilölle.
			`,
      },
      terms: {
        subheading: "iv. Sopimuksen ehdot",
        body: `
				Ostettu pysäköintilupa ei takaa pysäköintipaikkaa, mikäli kaikki pysäköintipaikat ovat varattuna. Luvanhaltija 
				on velvollinen tarkastamaan luvan käyttöoikeuden pysäköintialueella. Pysäköintilupaa saa käyttää ainoastaan 
				liikennemerkkien mukaisella pysäköintialueella. Lupa ei oikeuta pysäköimään pysäköinninvalvonnasta annetun 
				lain vastaisesti.
				<br><br>
        Pohjois-Pohjanmaan hyvinvointialueella on oikeus muuttaa ja rajoittaa pysäköintiä tarpeen mukaan, esimerkiksi
        kunnossapidon vuoksi. Hyvinvointialue ei vastaa internetissä tai ohjekartoissa olevista virheellisistä 
        tiedoista. Hyvinvointialue pidättää oikeuden muuttaa pysäköintialueiden liikenne- ja pysäköintijärjestelyjä 
        tapahtumien tai muiden vastaavien syiden ajaksi. Hyvinvointialue voi tiedottaa pysäköintiluvan 
        haltijaa kunnossapito- ja muista töistä sopivalla tavalla. Työmaiden tai muiden syiden aiheuttamista 
        luvan käytön estymisistä tai haitoista ei makseta korvausta.
        <br><br>
        Työntekijän vastuulla on huolehtia pysäköintioikeuden irtisanomisesta, mikäli työsuhde päättyy. Maksut 
        suoritetaan toistuvina maksuina eli maksut eivät pääty automaattisesti, vaikka työsuhde päättyisikin. 
        Työntekijän tulee myös huolehtia, että toistuvaan maksuun valittu maksukortti on voimassa sekä huolehtia 
        maksukortin päivityksestä maksulle. Pohjois-Pohjanmaan hyvinvointialue ei palauta maksuja tai valvontamaksuja
        näissä tapauksissa.
		`,
      },
      otherTerms: {
        subheading: "v. Muut ehdot",
        body: `
				Sopimus tulee voimaan, kun lupamaksu on kokonaisuudessaan suoritettu. Lupa voidaan peruuttaa ilman 
				irtisanomisaikaa luvan väärinkäyttötilanteissa (esim. luovuttaminen toisen osapuolen käyttöön) eikä 
				sopijapuolella ole tällöin oikeutta lupamaksun palautukseen tai muuhun korvaukseen. Tämän sopimuksen 
				pätevyyttä, tulkintaa ja soveltamista koskevat mahdolliset ristiriidat, joista osapuolet eivät pääse 
				yksimielisyyteen neuvotteluin, ratkaistaan tarvittaessa riita- asiana Oulun käräjäoikeudessa.`,
      },
    },
    close: "Sulje",
  },
  confirmEmailForm: {
    title: "Vahvista sähköpostiosoite",
    confirmationCode: "Syötä vahvistuskoodi",
    resendEmail: "Lähetä uudelleen",
    submit: "Vahvista",
    confirmEmail:
      "Sähköpostiisi on lähetetty vahvistuskoodi. Syötä se alla olevaan kenttään.",
    confirmationCodeError: "Vahvistuskoodi on virheellinen",
    confirmSuccess:
      "Sähköpostiosoite vahvistettu onnistuneesti. Voit nyt kirjautua sisään.",
    resendConfirmationCode: "Lähetä vahvistuskoodi uudelleen",
  },
  forgotPasswordForm: {
    title: "Unohtuiko salasana?",
    confirmPasswordReset: "Syötä vahvistuskoodi ja uusi salasana",
    userNotFound: "Käyttäjää ei löytynyt",
    submit: "Lähetä",
  },
  resetPasswordForm: {
    title: "Luo uusi salasana",
    password: "Syötä uusi salasana",
    confirmPassword: "Syötä uusi salasana uudelleen",
    resetPasswordSuccess:
      "Salasana vaihdettu onnistuneesti. Voit nyt kirjautua sisään.",
  },
  userDetailsForm: {
    title: "Syötä käyttäjätiedot",
    email: "Sähköposti",
    firstName: "Etunimi",
    lastName: "Sukunimi",
    editName: "Muokkaa nimeä",
    phoneNumber: "Puhelinnumero",
    editPhoneNumber: "Muokkaa puhelinnumeroa",
    changePassword: "Vaihda salasana",
    oldPassword: "Syötä vanha salasana",
    newPassword: "Syötä uusi salasana",
    confirmNewPassword: "Syötä uusi salasana uudelleen",
    wrongPasswordError: "Väärä salasana",
    passwordChangeSuccess: "Salasanan vaihto onnistui",
    submit: "Tallenna",
  },
  userDetailsPage: {
    title: "Omat tiedot, luvat ja ajoneuvot",
    purchaseParkingPermit: "Osta pysäköintilupa",
    parkingPermits: {
      title: "Luvat",
      cancel: "Peruuta tilaus",
      cancelError:
        "Tilauksen peruuttamisessa tapahtui virhe, tilaustasi ei peruttu",
      description:
        "Muista, että luvalla voi olla kerrallaan aktiivisena vain yksi ajoneuvo/rekisteritunnus.",
      activeVehicle: "Lupaan liitetty ajoneuvo",
      noActiveVehicle: "Lupaan ei ole liitetty ajoneuvoa.",
      invalidActiveVehicle: "Ajoneuvoa ei löydy listatuista ajoneuvoista",
      print: "Tulosta",
      changeActiveVehicle: "Vaihda ajoneuvoa",
      noParkingPermits: "Ei voimassa olevia lupia.",
      cancelConfirmationTitle: "Tilauksen päättäminen",
      cancelConfirmationText:
        "Oletko varma, että haluat lopettaa pysäköintiluvan tilauksen? Voit edelleen pysäköidä maksamasi luvan voimassaolon ajan.",
      cancelConfirmationTextPaidUntil:
        "Lupasi on tällä hetkellä voimassa {{ paid_until, string }} asti.",
      closeButton: "Jatka tilausta",
      confirmButton: "Kyllä, peruuta tilaus",
    },
    paymentCard: {
      paymentMethod: "Maksutapa",
      expiryText: "Voimassa {{month}}/{{year}}",
    },
  },
  vehiclesForm: {
    chooseVehicle: "Valitse ajoneuvo",
    title: "Ajoneuvot",
    subtitle: "Voit lisätä enintään kolme ajoneuvoa.",
    licensePlate: "Rekisteritunnus",
    add: "Lisää ajoneuvo",
    addInputLabel: "Uusi rekisteritunnus",
    addRequired: "Lisää ajoneuvo ostaaksesi pysäköintiluvan",
    edit: "Muokkaa ajoneuvoa {{ licensePlate, string }}",
    save: "Tallenna ajoneuvo",
    delete: "Poista ajoneuvo {{ licensePlate, string }}",
  },
  purchaseParkingPermit: {
    dayAbrv: "vrk",
    title: "Henkilöstön lupapysäköinnin verkkokauppa",
    description:
      "Henkilöstöllä on ostettavissa aluekohtaisia pysäköintilupia. Luvalla voi olla aktiivisena vain yksi rekisteritunnus.",
    productsQueryError:
      "Lupatuotteiden lataamisessa tapahtui virhe, yritä myöhemmin uudelleen",
    parkingPermitType: "Valitse tilattava lupa",
    validityStartDate: "Luvan voimassaolo alkaa",
    parkingPermitDuration:
      "Pohde alueellinen henkilöstöpysäköintioikeus: {{ duration, number }} vrk",
    includesVat: "sis. alv.",
    parkingPermitDescription: {
      p1: "Oikeuttaa pysäköimään sekä lämmitystolpallisella että tolpattomalla eli ns. kylmällä henkilöstöpysäköintipaikalla.",
      p2: "Ostettu lupa on voimassa hyvinvointialueen kaikissa toimipisteissä lukuunottamatta KYSin pysäköintihallinnassa olevaa KYS Puijon sairaalakampusta.",
    },
    validFromTitle: "Luvan voimassaolo alkaa",
    recurrentBilling: "Jatkuvan tilauksen hinta",
    recurrentBillingInfo:
      "Tuotteessa on käytössä toistuva maksu eli maksu uusiutuu automaattisesti 30 vuorokauden kuluttua ostosta, ellet irtisano tilausta siihen mennessä.",
    singlePaymentInfo:
      "Tuote on kertamaksullinen ja se tulee uusia luvan päättymisen jälkeen.",
    validFrom: "Voimassa alkaen:",
    validFromPurchase: "Maksuhetkestä",
    validTo: "Voimassaolo päättyy:",
    validDuration: "Voimassaolon kesto:",
    validDurationDays: "{{ days }} vuorokautta",
    paidUntil: "Uusiutuu",
    singlePaymentPrice: "Kertamaksu:",
    submit: "Varaa ja maksa",
    hasEnded: "Päättynyt",
    aboutToEnd: "Päättymässä",
    conflict: {
      title: "Ei tilattavissa",
      content:
        "Valitettavasti kaikki kohteen luvat ovat jo käytössä. Yritä myöhemmin uudelleen.",
    },
    successPage: {
      title: "Kassa",
      description: "Kiitos pysäköintiluvan tilauksesta.",
      orderDetails: "Tilaustiedot",
      permitDetails: "Tilauksen tiedot",
      orderDate: "Tilauspäivämäärä",
      orderNumber: "Tilausnumero",
      totalPrice: "Yhteensä",
      paymentMethod: "Maksutapa",
      invoicingAddress: "Laskutustiedot",
      error: "Tapahtui odottamaton virhe. Ota yhteys asiakaspalveluun.",
    },
    cancelPage: {
      title: "Kassa",
      description: "Maksu epäonnistui",
      returnToShop: "Palaa takaisin kauppaan",
      lede: "Joskus maksukorttimaksut epäonnistuvat.",
      reasons: {
        preamble: "Syitä voivat olla",
        causes: [
          "peruutit oston",
          "debit-korttiin liitetyllä pankkitilin saldo oli maksua pienempi",
          "luottokortin luottoraja ei riittänyt maksuun",
          "yhteysvirhe maksujärjestemän ja kortin myöntäneen pankin välillä",
        ],
        postamble:
          "Tarkista myös, että kortilla on sallittu verkko-ostot. Ota tarvittaessa yhteys pankkiisi",
      },
    },
    noProducts: "Sinulla ei ole yhtään tuotetta ostettavana",
  },
  paymentCardChangeSuccess: {
    title: "Maksukortin vaihto",
    success: "Maksukortin vaihto onnistui",
    error: "Maksukortin tietojen tallentamisessa tapahtui virhe",
  },
  paymentCardChangeCancel: {
    title: "Maksukortin vaihto",
    text: "Maksukortin vaihto peruuntui. Vanha maksukortti on edelleen käytössä.",
  },
  requestSignIn: {
    title: "Kirjaudu sähköpostiosoitteella",
    email: "Sähköpostiosoite",
    submit: "Lähetä",
    success: "Kirjautumislinkki lähetetty! Tarkista sähköpostisi.",
  },
  tokenHandler: {
    info: "Olet kirjautumassa lupapysäköinnin verkkokauppaan sähköpostiosoitteella",
    error:
      "Sähköpostikirjautuminen ei onnistunut tai on vanhentunut. Sähköpostikirjautumisen linkki on kertakäyttöinen ja voimassa 10 minuuttia tilaamisesta.",
    requestNewLink: "Pyydä uusi linkki <0>täältä</0>",
    submit: "Jatka",
  },
  expiredEmailToken: {
    header: "Kirjautuminen vanhentunut",
    text: "Kirjautumisesi sähköpostilinkin kautta on vanhentunut. Sähköpostikirjautumista voi käyttää tietoturvasyistä vain 30 minuutin ajan. Voit tilata uuden kirjatumislinkin <0>täältä</0>.",
  },
};
